/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "cart-7fbd2109--svg-sprite",
  "use": "cart-7fbd2109--svg-sprite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"cart-7fbd2109--svg-sprite\"><path d=\"M25.34 9.856H10.017L8.65 6.475C8.54 6.203 8.34 6 8.027 6h-3.38A.653.653 0 004 6.647v.256c0 .353.294.647.647.647h2.775l1.223 3.025c.006.033.01.066.024.1 1.02 2.493 2.034 4.989 3.043 7.486a.898.898 0 00.086.157c.116.231.304.398.588.398h9.86c.315 0 .513-.204.624-.475l3.093-7.567c.163-.397-.241-.818-.623-.818zm-3.695 7.31h-8.656c-.785-1.919-1.565-3.84-2.343-5.76H24l-2.355 5.76zm-6.807 2.374a.656.656 0 00-.193-.019.66.66 0 00-.19.019c-1.154.144-1.967 1.013-2.031 2.202-.068 1.252 1.068 2.16 2.221 2.222 1.251.068 2.159-1.069 2.22-2.222.065-1.181-.944-2.055-2.027-2.202zm-.193 2.874c-.866-.047-.867-1.297 0-1.343.867-.047.862 1.296 0 1.343zm5.535-2.874a.66.66 0 00-.193-.019.66.66 0 00-.19.019c-1.154.144-1.967 1.013-2.032 2.202-.067 1.252 1.07 2.16 2.222 2.222 1.252.068 2.159-1.069 2.22-2.222.064-1.18-.944-2.055-2.027-2.202zm-.193 2.874c-.867-.047-.867-1.297 0-1.343.867-.047.862 1.296 0 1.343z\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
